import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import order from './ims/order'
import baseDict from './base/dict'
import cmc from './cmc/cmc'
import web from './cms/web'
import pmc from './pmc/pmc'
import common from './common'
import ims from './ims/ims'
import base from './base/base'
import mcc from './mcc/mcc'
import mmc from './mmc/mmc'
import wechat from './wechat/wechat'
import myg from './myg/myg'

const cn = {
  routeName: {
    home: '主页',
    dictionary: '数据字典',
    dictionaryList: '字典管理',
    icon: '省市区',
    builtInIcon: '省市区',
    shuttleBox: '系统',
    systemManage: '系统管理',
    systemList: '系统列表',
    baseInfo: '基础资料',
    table: '用户模块',
    orgs: '组织模块',
    channel: '渠道模块',
    jxcmk: '资金管理模块',
    region: '区域模块',
    salesman: '业务员模块',
    warehouse: '仓库',
    logisticsCompany: '物流公司',
    account: '账户',
    dearManage: '经销商管理',
    dealerType: '经销商类型',
    dealerList: '经销商列表',
    dearAdd: '增加经销商',
    updateDear: '修改经销商',
    org: '组织管理',
    userList: '用户管理',
    systemSettings: '系统设置',
    menuList: '菜单管理',
    urlList: 'Url管理',
    roleList: '角色管理',
    functionList: '功能管理',
    userEdit: '用户修改',
    userAdd: '用户添加',
    addDictionary: '字典添加',
    updateDictionary: '字典修改',
    menuEdit: '菜单编辑',
    menuAdd: '新增菜单',
    urlEdit: 'Url修改',
    roleEdit: '角色编辑',
    roleAdd: '新增角色',
    addOrg: '新增组织',
    updateOrg: '组织信息修改',
    updateRegion: '区域信息修改',
    addRegion: '增加区域信息',
    addSalesman: '增加业务员',
    addWarehouse: '新增仓库',
    updateWarehouse: '修改仓库',
    addLogisticsCompany: '新增物流公司',
    updateLogisticsCompany: '修改物流公司',
    addAccount: '新增账户',
    updateAccount: '修改账户',
    updateSalesman: '修改业务员',
    productManage: '商品模块',
    productInfo: '商品信息',
    productType: '商品类别',
    productTypeAdd: '新增商品类别',
    productTypeEdit: '修改商品类别',
    productDescription: '商品描述',
    productAttribute: '商品属性',
    productAttributeAdd: '新增商品属性',
    productAttributeEdit: '修改商品属性',
    productTradeMark: '商品品牌',
    productUnit: '商品单位',
    productList: '商品列表',
    productAdd: '新增商品',
    productEdit: '修改商品',
    activity: '营销活动',
    sales: '商品促销',
    salesByMoney: '金额促销',
    presentationByMoney: '新增满赠',
    declineByMoney: '新增直降',
    discountByMoney: '新增打折',
    salesByQuantity: '按数量促销',
    presentationByQuantity: '新增满赠',
    declineByQuantity: '新增直降',
    discountByQuantity: '新增满折',
    salesByOrderDir: '订单促销',
    salesByOrder: '订单促销',
    presentationByOrder: '新增满赠',
    declineByOrder: '新增满减',
    discountByOrder: '新增满折',
    orderManage: '订单管理',
    orderList: '订单列表',
    orderDetail: '订单详情',
    orderAdd: '订单新增',
    orderUpdate: '订单编辑',
    orderGathering: '订单收款',
    orderDeliver: '订单发货',
    orderDetailList: '订货明细',
    deliverList: '发货单列表',
    deliverVerify: '发货单审核',
    deliverDetail: '发货单详情',
    deliverUpdate: '发货单修改',
    stockManage: '库存管理',
    stockList: '库存列表',
    saleList: '动销数据',
    DesignerAdd: '设计师新增',
    DesignerUpdate: '设计师修改',
    DesignerList: '设计师列表',
    DesignerManage: '设计师管理',
    memberManage: '会员管理',
    memberList: '直接客户',
    memberAdd: '会员新增',
    memberEdit: '会员修改',
    memberType: '会员类型',
    memberTypeAdd: '会员类型新增',
    agentList: '代理商',
    agentAdd: '新增代理商',
    agentUpdate: '修改代理商',
    caseList: '案例列表',
    caseEdit: '案例编辑',
    caseAdd: '案例新增',
    caseView: '案例查看',
    caseManage: '案例管理',
    caseTypeList: '案例类型列表',
    roomManage: '展厅管理',
    roomList: '展厅列表',
    roomEdit: '展厅修改',
    roomView: '展厅查看',
    roomAdd: '新增展厅',
    roomHomepage: '展厅主页',
    webManage: '网页管理',
    webSimpleColumnAboutUs: '关于我们',
    webSimpleColumnContactUs: '联系我们',
    webSimpleColumnDeliveryMode: '送货方式',
    webSimpleColumnFrequentlyQuestions: '常见问题解决',
    webSimpleColumnLegalDeclarations: '法律声明',
    webSimpleColumnPrivacyClauses: '隐私条款',
    webSimpleColumnTermsConditions: '条款与条项',
    recruitJoinUs: '加入我们',
    vipDesignerList: '设计师',
    vipDesignerListAdd: '新增设计师',
    vipDesignerListEdit: '修改设计师',
    vipDesignerListView: '查看设计师',
    tips: '提示',
    tipsList: '提示列表',
    tipsAdd: '提示新增',
    tipsEdit: '提示编辑',
    joinUs: '加入我们',
    postList: '岗位列表',
    postAdd: '新增岗位',
    postEdit: '编辑岗位',
    wechatService: '微信服务',
    wechatInfo: '微信信息',
    wechatBasicInfo: '微信基本信息',
    wechatConfAdd: '新增微信基本信息',
    wechatConfEdit: '修改微信基本信息',
    wechatForeverQRCodeList: '永久二维码',
    wechatForeverQRCodeAdd: '新增永久二维码',
    wechatForeverQRCodeEdit: '修改永久二维码'
  },
  rightMenu: {
    close: '关闭',
    closeOther: '关闭其他',
    closeAll: '全部关闭'
  },
  role: {
    superAdmin: '超级管理员',
    admin: '管理员',
    ordinary: '普通用户'
  },
  userDropdownMenu: {
    basicInfor: '基本资料',
    changePassword: '修改密码',
    logout: '退出'
  },
  ...common,
  ...baseDict,
  ...order,
  ...cmc,
  ...pmc,
  ...ims,
  ...base,
  ...web,
  ...mcc,
  ...mmc,
  ...zhLocale, //  合并element-ui内置翻译
  ...wechat,
  ...myg
}
export default cn



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cn.js